import request from '@shared/api/request';
import {
    API_BOOKING_DEVICES_PATH,
    API_BOOKING_PATH,
    API_FAVORITES_PATH,
    API_SCHEMES_PATH,
} from '@shared/constants/pathsConstants';
import { FavoriteObjectEntity, FavoriteObjectId } from '@features/favorites/types';

export const MAP_ENTITY_TO_API_PATH: Record<FavoriteObjectEntity, string> = {
    [FavoriteObjectEntity.SCHEMES]: API_SCHEMES_PATH,
    [FavoriteObjectEntity.BOOKING_DEVICES]: `${API_BOOKING_PATH}/${API_BOOKING_DEVICES_PATH}`,
};

export const MAP_ENTITY_TO_PARAM_NAME: Record<FavoriteObjectEntity, string> = {
    [FavoriteObjectEntity.SCHEMES]: 'scheme_id',
    [FavoriteObjectEntity.BOOKING_DEVICES]: 'pk',
};

export function getFavorites(entity: FavoriteObjectEntity): Promise<FavoriteObjectId[]> {
    return request.get(`${MAP_ENTITY_TO_API_PATH[entity]}/${API_FAVORITES_PATH}/`);
}

export function addFavorite(entity: FavoriteObjectEntity, id: FavoriteObjectId) {
    return request.post(`${MAP_ENTITY_TO_API_PATH[entity]}/${API_FAVORITES_PATH}/`, {
        [MAP_ENTITY_TO_PARAM_NAME[entity]]: id,
    });
}

export function deleteFavorite(entity: FavoriteObjectEntity, id: FavoriteObjectId) {
    return request.delete(`${MAP_ENTITY_TO_API_PATH[entity]}/${API_FAVORITES_PATH}/`, {
        data: { [MAP_ENTITY_TO_PARAM_NAME[entity]]: id },
    });
}
